"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var EmailMayBounceConfirmationComponent = function EmailMayBounceConfirmationComponent(_ref) {
  var email = _ref.email,
      modalProps = (0, _objectWithoutProperties2.default)(_ref, ["email"]);
  return /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, (0, _extends2.default)({
    title: "Couldn`t validate email",
    submitButtonText: "Use this email",
    cancelButtonText: "Replace email"
  }, modalProps), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "Before you continue... we wanted to make sure that this email would work, but we couldn't validate it. There's a chance that this email will bounce. How do you wish to continue?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, email)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "How do you wish to continue?"));
};

EmailMayBounceConfirmationComponent.propTypes = {
  email: _propTypes.default.string.isRequired
};
var _default = EmailMayBounceConfirmationComponent;
exports.default = _default;